import draggable from 'vuedraggable';
export default {
  name: 'SortList',
  components: {
    draggable
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },

    /**
     * 控件展示列数
     */
    col: {
      type: Number,
      default: 3
    }
  },
  computed: {
    itemCls() {
      return {
        item: true,
        [`item-${this.col}`]: true
      };
    },

    itemStyle() {
      const {
        col
      } = this;
      return {
        'flex-basis': 100 / col + '%'
      };
    }

  },
  methods: {
    notifyChange() {
      this.$emit('change', this.value);
    },

    sortChange(evt) {
      this.notifyChange();
    },

    checkChange(index, $event) {
      this.notifyChange();
    }

  }
};